import { inject, Injectable, Injector } from '@angular/core';

import { TenantStrategy } from '@generator-strategies/tenant-strategy';

import { OrganizationService } from './organization.service';

/**
 * Lazy injection to break circular dependency:
 * OrganizationService → OrganizationPublicInfoService → TenantStrategy → OrganizationService
 */
@Injectable({ providedIn: 'root' })
export class AppTenantStrategy extends TenantStrategy {
  private readonly injector = inject(Injector);
  private readonly _organizationService?: OrganizationService;

  private get organizationService(): OrganizationService {
    return this._organizationService ? this._organizationService : this.injector.get(OrganizationService);
  }

  override organizationId(): string | undefined {
    return this.organizationService.organizationId();
  }
}
